import { createAction } from 'redux-actions';
import {
    SET_HISTORYVALUE,
    SET_HISTOERYRESULT
} from '../constants/actionTypes';
import { doGet, doPost } from '../utils/AjaxRequests'
import _ from 'lodash'
import { apiPrefixUrl } from '../utils/connection'
import { format, parse, isValid } from 'date-fns'
import Swal from 'sweetalert2'
import { history } from '../router/history'

export const setHistoryValue = createAction(SET_HISTORYVALUE)
export const setHistoryResult = createAction(SET_HISTOERYRESULT)

export const searchHistory = () => {
    return (dispatch, getState) => {
        const search = (getState().getIn(["reserveHistory", "search"])).toJS()

        if(!search.PAT_IDNO || !search.BIRTHDAY){
            Swal.fire("尚有欄位未填寫", "", "error")
            return
        }

        dispatch(setHistoryValue({
            page:"search",
            field:"loading",
            value: true
        }))
        doPost(apiPrefixUrl, {
            "api": "APCBookingFind4PatientV2",
            "PAT_IDNO": search.PAT_IDNO,
            // "TICKET_NO": search.TICKET_NO,
            "BIRTHDAY": search.BIRTHDAY,
            "USER_ID":"patient"
        })
            .then((data) => {
                if (data.status && data.data) {                    
                    dispatch(setHistoryResult({ value: data.data }))
                    history.push('/historyResult')
                    dispatch(setHistoryValue({
                        page:"search",
                        field:"loading",
                        value: false
                    }))
                } else {
                    history.push('/search')
                    throw Error(data.message)
                   
                }
            })
            .catch((e) => {
                Swal.fire(e.message, "", "error")
                dispatch(setHistoryValue({
                    page:"search",
                    field:"loading",
                    value: false
                }))
            })

    }
}

export const cancelReserve = (PAT_IDNO, BIRTHDAY, TICKET_NO, TOKEN) => {
    return (dispatch, getState) => {
        const result = (getState().getIn(["reserveHistory", "result"])).toJS()

        Swal.fire({
            title: '確定取消預約？',
            // showDenyButton: true,
            showCancelButton: true,
            confirmButtonText: "確定",
            cancelButtonText: "取消"
            // denyButtonText: `Don't save`,
        }).then((swalResult) => {
            /* Read more about isConfirmed, isDenied below */
            if (swalResult.isConfirmed) {
                doPost(apiPrefixUrl, {
                    "api": "APCBookingCancel4PatientV2",
                    "PAT_IDNO": PAT_IDNO,
                    "TICKET_NO": TICKET_NO,
                    // "BIRTHDAY": BIRTHDAY,
                    "USER_ID":"PATIENT",
                    "SPNO":"",
                    "TOKEN":TOKEN

                }).then((data) => {
                    if (data.status && data.data) {
                        Swal.fire(data.message, "", "success")
                        // history.push('/search')
                        // dispatch(searchHistory())
                        const search = (getState().getIn(["reserveHistory", "search"])).toJS()
                        doPost(apiPrefixUrl, {
                            "api": "APCBookingFind4PatientV2",
                            "PAT_IDNO": search.PAT_IDNO,
                            // "TICKET_NO": search.TICKET_NO,
                            "BIRTHDAY": search.BIRTHDAY,
                            "USER_ID":"patient"
                        })
                        .then((sdata) => {
                            if(!sdata.status || !sdata.data){
                                history.push('/search')
                            }else{
                                dispatch(setHistoryResult({ value: sdata.data }))
                                history.push('/historyResult')
                            }
                        })
                    }else{
                        Swal.fire(data.message, "", "error")
                    }
                })
            }
        })


    }
}